import React, { Component } from "react";
import DashboardLayout from "../../../templates/dashboard-template/index";
import { useTranslation } from 'react-i18next';

const Support = () => {  
  const [t, i18n] = useTranslation('common');
    return (
     <DashboardLayout>
       <>
       <div className="page-header-title">
            <h5 className="mt-3 mb-3">Support</h5>
            <p>{t('support.demo')}</p>
        </div>
       </>
     </DashboardLayout>
      
      
    );
   
}
export default Support;